import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { HttpClient } from '@angular/common/http';
import { ConstantsService } from './constants.service';
import { AnnouncementModel } from '../models/announcement-model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AnnouncementsService extends BaseService {

  constructor(public override http: HttpClient,
      public override constants: ConstantsService) {
      super(http, constants, constants.api_announcements);
    }
  
    getTodayAnnouncements(): Observable<AnnouncementModel> {
        return this.http.get<AnnouncementModel>(this.constants.api_announcements + environment.api_code)
      }
}
